import { getLogger } from "./UnifiedLogger.jsx";

const { logInfo } = getLogger("AppConstant", true);

export const LANGUAGES = [
  { code: "en", label: "English", isActive: true },
  { code: "as", label: "Assamese (অসমীয়া)", isActive: true },
  { code: "bn", label: "Bengali (বাংলা)", isActive: true },
  { code: "brx", label: "Bodo (बड़ो)", isActive: true },
  { code: "doi", label: "Dogri (डोगरी)", isActive: true },
  { code: "gom", label: "Goan Konkani (गोवा कोंकणी)", isActive: true },
  { code: "gu", label: "Gujarati (ગુજરાતી)", isActive: true },
  { code: "hi", label: "Hindi (हिन्दी)", isActive: true },
  { code: "kn", label: "Kannada (ಕನ್ನಡ)", isActive: true },
  { code: "ks", label: "Kashmiri (کٲشُر)", isActive: true },
  { code: "mai", label: "Maithili (मैथिली)", isActive: true },
  { code: "ml", label: "Malayalam (മലയാളം)", isActive: true },
  { code: "mni", label: "Manipuri (মণিপুরী)", isActive: true },
  { code: "mr", label: "Marathi (मराठी)", isActive: true },
  { code: "ne", label: "Nepali (नेपाली)", isActive: true },
  { code: "or", label: "Odia (ଓଡ଼ିଆ)", isActive: true },
  { code: "pa", label: "Punjabi (ਪੰਜਾਬੀ)", isActive: true },
  { code: "sa", label: "Sanskrit (संस्कृत)", isActive: true },
  { code: "sat", label: "Santali (संताली)", isActive: true },
  { code: "sd", label: "Sindhi (سنڌي)", isActive: true },
  { code: "ta", label: "Tamil (தமிழ்)", isActive: true },
  { code: "te", label: "Telugu (తెలుగు)", isActive: true },
  { code: "ur", label: "Urdu (اردو)", isActive: true },
];

export const getUnsupportedLanguages = () => {
  return LANGUAGES.map((lang) => lang.code);
};
logInfo(
  "SUPPORTED_LANGUAGE",
  "Live Languages",
  getUnsupportedLanguages().join(", ")
);

export const getLanguageData = (code) =>
  LANGUAGES.find((lang) => lang.code === code) || null;



// let a={
//   "CENTRAL": [
//     "CENTRAL", "UNION", "NATIONAL", "FEDERAL", "INTERSTATE",
//     "PARLIAMENT", "LOKSABHA", "RAJYASABHA", "UNIONMINISTRY", "CENTRALDEPARTMENT",
//     "NATIONALAUTHORITY", "CONSTITUTIONALBODY", "CURRENCY", "INCOMETAX", "GSTN",
//     "CUSTOMS", "EXCISE", "CENTRALBANK", "RBI", "NATIONALFINANCE",
//     "UNIONBUDGET", "NATIONALREVENUE", "RAILWAYS", "METRO", "NATIONALHIGHWAYS",
//     "CIVILAVIATION", "AIRPORTS", "PORTS", "SHIPPING", "MARITIME",
//     "NHAI", "DEFENCE", "ARMY", "NAVY", "AIRFORCE",
//     "PARAMILITARY", "CRPF", "BSF", "CISF", "NSG",
//     "NIA", "TELECOM", "SPECTRUM", "INTERNETGOVERNANCE", "NIC",
//     "ISRO", "SPACE", "DIGITALINDIA", "UIDAI", "AADHAAR",
//     "PASSPORT", "VISA", "NATIONALSCHOLARSHIP", "CENTRALPENSION", "EPFO",
//     "ESIC", "INCOMESUPPORT", "NATIONALWELFARE", "EXTERNALAFFAIRS", "FOREIGNTRADE",
//     "EMBASSY", "CONSULATE", "INTERNATIONALTREATY", "BORDERISSUE", "CBI",
//     "ED", "NCB", "CENTRALVIGILANCE", "UGC", "AICTE",
//     "NATIONALCOMMISSION", "ELECTIONCOMMISSION", "COAL", "PETROLEUM", "NATURALGAS",
//     "POWERGRID", "NTPC", "NATIONALENERGY", "FORESTCLEARANCE", "ENVIRONMENTMINISTRY",
//     "NATIONALPARK",
//     "PRESIDENTSOFFICE", "PRIMEMINISTER", "PMO", "CABINETSECRETARY", "NITI",
//     "NITIAYOG", "PLANNINGCOMMISSION", "FINANCECOMMISSION", "COMPTROLLER", "CAG",
//     "SUPREMECOURT", "HIGHCOURT", "NATIONALGREENTRIBUNAL", "NCLT", "NCLAT",
//     "ITAT", "CESTAT", "DRAT", "UPSC", "SSC",
//     "STAFFSELECTIONCOMMISSION", "IBPS", "NABARD", "SIDBI", "EXIM",
//     "EXPORTIMPORTBANK", "IRDA", "SEBI", "PFRDA", "FSSAI",
//     "DRUGCONTROLLER", "DCGI", "CDSCO", "AYUSH", "ICMR",
//     "CSIR", "DBT", "DST", "DAE", "DOS",
//     "DRDO", "BEL", "HAL", "ORDINANCEFACTORY", "COASTGUARD",
//     "ITBP", "SSB", "ASSRIFLES", "RPF", "RAILWAYPOLICE",
//     "CISFSECURITY", "SECURITYBUREAU", "IB", "RAW", "NTRO",
//     "NCERT", "CBSE", "ICSE", "NIOS", "IGNOU",
//     "IIT", "IIM", "NIT", "IIIT", "AIIMS",
//     "NLU", "NLSIU", "NIFT", "NID", "CEPT",
//     "IISER", "NISER", "TIFR", "BARC", "IISC",
//     "JNTU", "INDIANOIL", "BPCL", "HPCL", "GAIL",
//     "ONGC", "OIL", "NHPC", "SJVN", "THDCIL",
//     "NEEPCO", "PGCIL", "POWERFIN", "REC", "IREDA",
//     "SECI", "BEE", "CEA", "APTEL", "CIL",
//     "NLC", "SAIL", "RINL", "NMDC", "MOIL",
//     "HZL", "BALCO", "NAL", "NATIONALAIRWAYS", "AAI",
//     "DGCA", "BCAS", "AERA", "COCHINSHIPYARD", "MDL",
//     "GSL", "HSL", "GRSE", "PORTAUTHORITY", "MUMBAIPORT",
//     "KANDLAPORT", "CHENNAIPORT", "VIZAGPORT", "PARADIPPORT", "KOLKATAPORT",
//     "JAWAHARLALPORT", "NHIDCL", "NHPC", "IRSDC", "DFCCIL",
//     "IRCON", "RITES", "RAILTEL", "IRCTC", "CRIS",
//     "RAILVIKAS", "KONKAN", "METRO", "DMRC", "BMRC",
//     "MMRDA", "CMRL", "LMRC", "NMRC", "JMRC",
//     "RRTS", "NCRTC", "HUDCO", "NHB", "NBCC",
//     "CPWD", "PWD", "MES", "BRO", "BORDERROADS",
//     "MORTH", "NHDP", "PMGSY", "BHARATMALA", "SAGARMALA",
//     "SMARTCITY", "AMRUT", "SBM", "SWACHHBHARAT", "PMAY",
//     "PMJDY", "PMJJBY", "PMSBY", "APY", "ATAL",
//     "PMKVY", "DDUGKY", "NSDC", "MSDE", "NAPS",
//     "NRLM", "DAY", "NULM", "PMEGP", "MUDRA",
//     "STANDUPMITRA", "STARTUP", "MSME", "CGTMSE", "CLCSS",
//     "KVIC", "KVIB", "COIR", "HANDLOOM", "HANDICRAFT",
//     "NMCP", "NCDC", "SFAC", "FISHERIES", "DAHD",
//     "NDDB", "ICAR", "IARI", "KRISHI", "RKVY",
//     "PMKSY", "PARAMPARAGAT", "PKVY", "NMSA", "NFSM",
//     "SMAM", "AGMARKNET", "ENAM", "APMC", "MSP",
//     "FCI", "CWC", "SWC", "NAFED", "NCCF",
//     "TRIFED", "NSSO", "CSO", "MOSPI", "DGE",
//     "LABOURBUREAU", "ESIS", "EPFORGANIZATION", "NPS", "PFRDA",
//     "PENSIONS", "CGHS", "CSMA", "ECHS", "NHPM",
//     "PMJAY", "RSBY", "JSY", "RBSK", "NRHM",
//     "NHM", "NACO", "RNTCP", "NVBDCP", "NPCDCS",
//     "NMHP", "NTCP", "NACP", "AIIA", "CCRAS",
//     "CCRUM", "CCRYN", "CCRS", "CCAH", "AYUSHMAN",
//     "ESANJEEVANI", "ABDM", "NDHM", "PHC", "CHC",
//     "DISTRICTHOSP", "MEDICALCOLLEGE", "PGIMER", "NIMHANS", "SGPGI",
//     "JIPMER", "NIHFW", "NIOH", "NIRTH", "NIRRH",
//     "ICMRDELHI", "VCRC", "NICD", "NJIL", "NCDIR",
//     "RMRC", "NICED", "NARI", "NIMS", "NIREH",
//     "ITBP", "CISF", "DOPT", "DARPG", "DSPE",
//     "CABSEC", "CABINETAFFAIRS", "COAL", "MINES", "STEEL",
//     "HEAVYINDUSTRY", "CHEMICALS", "FERTILIZERS", "TEXTILES", "JUTE",
//     "FOODPROCESSING", "MOFPI", "COMMERCE", "INDUSTRY", "DPIIT",
//     "IPR", "PATENTS", "TRADEMARKS", "COPYRIGHT", "DESIGNS",
//     "GI", "WIPO", "WTO", "BRICS", "SAARC",
//     "ASEAN", "G20", "UNSC", "UNESCO", "WHO",
//     "UNICEF", "UNDP", "FAO", "ILO", "IMF",
//     "WORLDBANK", "ADB", "AIIB", "NDB", "BIMSTEC",
//     "SCO", "IBSA", "QUAD", "IORA", "COMMONWEALTH",
//     "NAM", "MEA", "PASSPORT", "CONSULAR", "EMIGRATION",
//     "OCI", "PIO", "EMIGRATE", "ECR", "ECNR",
//     "PROTECTOR", "MADAD", "EVISIT", "EVISA", "STAYVISA",
//     "WORKVISA", "STUDENTVISA", "BUSINESSVISA", "DIPLOMATICVISA", "OFFICIALVISA",
//     "TOURISTVISA", "MEDICALVISA", "CONFERNCEVISA", "TRANSITVISA", "FOREIGNERS",
//     "FRRO", "FRO", "FCAT", "INTERPOL", "CID",
//     "STF", "ATS", "SOG", "CRIME", "FORENSIC",
//     "CFSL", "GEQD", "DFS", "NARCOTICS", "CONTRABAND",
//     "SMUGGLING", "MONEYLAUNDERING", "HAWALA", "BENAMI", "BLACKMONEY",
//     "WHITEPAPER", "ECONOMICSURVEY", "FISCALDEFICIT", "REVENUEDEFICIT", "PRIMARYDEFICIT",
//     "MONETARYPOLICY", "REPORATE", "REVERSEREPO", "CRR", "SLR",
//     "BANKRATE", "MSF", "LIQUIDITY", "INFLATION", "CPI",
//     "WPI", "GDP", "GVA", "GNP", "NNP",
//     "PERCAPITA", "HDI", "GINI", "POVERTY", "BPL",
//     "MULTIDIMENSIONAL", "NFSA", "TPDS", "OMSS", "BUFFER",
//     "STRATEGIC", "KEROSENE", "LPG", "UJJWALA", "PAHAL",
//     "DBTL", "SATAT", "CNG", "PNG", "GASCO",
//     "PNGRB", "DGH", "OIDB", "MoPNG", "PCRA",
//     "PETRONET", "BRAHMAPUTRA", "NUMALIGARH", "MANGALORE", "CHENNAI",
//     "BINA", "KOCHI", "MATHURA", "PANIPAT", "PARADIP",
//     "HALDIA", "GUWAHATI", "BARAUNI", "BONGAIGAON", "DIGBOI",
//     "DULIAJAN", "LPGVITRAK", "INDANE", "BHARAT", "HP"
//   ],
//   "STATE": [
//     "STATE", "REGIONAL", "LOCAL", "STATEGOVT", "STATEDEPARTMENT",
//     "DISTRICT", "TEHSIL", "TALUKA", "MUNICIPAL", "PANCHAYAT",
//     "BLOCKOFFICE", "STATESCHEME", "POLICE", "TRAFFICPOLICE", "LAWANDORDER",
//     "CRIMEMATTER", "PRISON", "FIR", "LOCALINVESTIGATION", "LAND",
//     "REVENUE", "LANDRECORD", "REGISTRATION", "PROPERTYTAX", "AGRICULTURALLAND",
//     "SURVEY", "MUTATION", "ROADS", "RURALROADS", "LOCALWATER",
//     "SEWERAGE", "SANITATION", "STREETLIGHT", "MUNICIPALWASTE", "MARKETREGULATION",
//     "HEALTH", "HOSPITAL", "PRIMARYHEALTH", "STATEEDUCATION", "SCHOOLS",
//     "STATECOLLEGE", "SCHOLARSHIPSTATE", "WELFAREOFFICE", "SOCIALJUSTICE", "AGRICULTURE",
//     "FARMERISSUES", "IRRIGATION", "PADDYPROCUREMENT", "SEEDSUPPLY", "FERTILIZERDISTRIBUTION",
//     "RURALDEVELOPMENT", "MGNREGA", "STATETRANSPORT", "BUSCORPORATION", "LOCALPERMIT",
//     "VEHICLEREGISTRATION", "DRIVINGLICENSE", "ELECTRICITYBOARD", "WATERBOARD", "LOCALHOUSING",
//     "URBANDEVELOPMENT", "BUILDINGPERMISSION", "LOCALPROPERTY", "RATIONCARD", "PDS",
//     "OLDAGEPENSION", "LOCALSUBSIDY", "CASTECERTIFICATE", "RESIDENCECERTIFICATE", "STATEFOREST",
//     "LOCALPOLLUTION", "MINORRIVERS", "LOCALWILDLIFE", "SANDMINING", "COMMUNITYLAND",
//     "GOVERNOR", "CHIEFMINISTER", "STATEASSEMBLY", "VIDHANMANDAL", "VIDHANSABHA",
//     "VIDHANPARISHAD", "LEGISLATIVECOUNCIL", "MLA", "MLC", "SPEAKER",
//     "DEPUTYSPEAKER", "CHIEFSECRETARY", "ADDITIONALCS", "PRINCIPALSECRETARY", "SECRETARY",
//     "COMMISSIONER", "DIVCOM", "DM", "COLLECTOR", "DC",
//     "SDM", "SUBDIVISIONAL", "TEHSILDAR", "BDO", "BLOCKDEV",
//     "CO", "CIRCLEOFF", "PATWARI", "LEKHPAL", "KARAMCHARI",
//     "VLW", "VILLAGELEVEL", "GRAMSEVAK", "SARPANCH", "PRADHAN",
//     "MUKHIYA", "PANCH", "WARDMEMBER", "CORPORATOR", "MAYOR",
//     "DEPUTYMAYOR", "MUNICIPALCOMM", "CHIEFEXEC", "TOWNPLANNER", "HEALTHOFFICER",
//     "ENGINEERMUN", "ACCOUNTSMUN", "TAXCOLLECTOR", "ZONALADM", "WARDADM",
//     "STATEPOLICE", "DGP", "ADGP", "IGP", "DIG",
//     "SSP", "SP", "ASP", "DSP", "INSPECTOR",
//     "SI", "ASI", "HEADCONSTABLE", "CONSTABLE", "HOMEPOLICE",
//     "TRAFFICBRANCH", "CRIMEBRANCH", "SPECIALBRANCH", "CID", "EOW",
//     "ACB", "ANTICORRUPTION", "VIGILANCE", "LOCALTHANA", "CHAUKI",
//     "OUTPOST", "CHECKPOST", "PCR", "DIALPOLICE", "WOMENCELL",
//     "JUVENILEJUSTICE", "JAILSUPER", "PRISONADM", "CORRECTIONAL", "OPENJAIL",
//     "CENTRALJAIL", "DISTRICTJAIL", "SUBJAIL", "LOCKUP", "CUSTODY",
//     "LANDREVENUE", "TEHSILOFFICE", "REVENUEVILLAGE", "PATWARIHALKA", "KHASRA",
//     "KHATONI", "KHATAUNI", "BHUNAKASHAH", "JAMABANDI", "FARD",
//     "GIRDHAWARI", "SHAJRA", "MUTATION", "PARTITIONDEED", "CONVEYANCE",
//     "SALEDEED", "REGISTRY", "STAMPDUTY", "FRANKING", "SUBREGISTRAR",
//     "TALATHI", "KARNAM", "ADHIKARI", "MANDAL", "GRAMPANCHAYAT",
//     "BLOCKLEVEL", "ZILLALEVEL", "SUBDIVISIONLEVEL", "RURALROADS", "PRADHANMANTRI",
//     "STATESCHEME", "CMSCHEME", "STATEPENSION", "WIDOWPENSION", "DISABILITYPENSION",
//     "HANDICAPPENSION", "FARMERPENSION", "LABOURWELFARE", "BCWELFARE", "SCWELFARE",
//     "STWELFARE", "OBCWELFARE", "MINORITYWELFARE", "WOMENDEV", "CHILDWELFARE",
//     "AGANWADI", "ICDS", "POSHAN", "MIDDAY", "SCHOOLMEAL",
//     "STATEBOARD", "SECONDARYEDU", "HIGHEREDU", "PRIMARYEDU", "ADULTEDU",
//     "VOCATIONAL", "POLYTECHNIC", "ITI", "SKILLDEV", "STATEUNIV",
//     "DEEMEDUNIV", "AFFILIATEDCOLLEGE", "GOVERNMENTCOLLEGE", "AIDEDSCHOOL", "UNAIDED",
//     "RECOGNITION", "AFFILIATIONSEC", "SCHOOLINSPECTOR", "EDUCATIONOFFICER", "DEO",
//     "BEO", "DPEP", "SSA", "RMSA", "SCERT",
//     "SIET", "DIET", "EDUCATIONALDEVELOPMENT", "TEACHERTRAINING", "BTCED",
//     "DEDCOURSE", "ELIGIBILITYTEST", "TET", "CTET", "STET",
//     "HEALTHDEPT", "DIRECTORHEALTH", "CMHO", "ACMO", "BMO",
//     "MOIC", "MEDICALOFFICER", "DISTRICTHOSP", "SUBDIVISIONALHOSP", "CHC",
//     "PHC", "SUBCENTRE", "AANGANWADI", "ASHA", "ANM",
//     "MPHW", "LABTECH", "PHARMACIST", "NURSING", "STATEAMBULANCE",
//     "AYUSHDEPT", "HOMEOPATHY", "UNANI", "SIDDHA", "NATUROPATHY",
//     "AYURVEDA", "DRUGCONTROLLER", "FOODSAFETY", "AYUSHCOLLEGE", "GOVTHOSP",
//     "MEDICALSTORE", "DRUGSTORE", "BLOODBANK", "LABTEST", "XRAY",
//     "DIAGNOSTIC", "PATHOLOGY", "MENTALHEALTH", "EPIDEMIC", "DISEASE",
//     "VACCINATION", "IMMUNIZATION", "PULSE", "MISSIONINDRA", "JANANI",
//     "JANANISURAKSHA", "INCENTIVE", "MATERNAL", "INFANT", "CHILDHEALTH",
//     "NUTRITION", "ADOLESCENT", "SCHOOLHEALTH", "TBALLIANCE", "MALARIA",
//     "DENGUE", "CHOLERA", "JAPA", "ENCEPHALITIS", "VECTORBORNE",
//     "WATERBORNE", "DISEASESURV", "FOODPROCESSSTATE", "FARMERSCOMMISSION", "MARKETYARD",
//     "MANDI", "KRUSHIUNNNATI", "AGRICULTUREOFF", "DIRECTORAGRI", "JOINTDIR",
//     "DEPUTYDIR", "ADAOFC", "AGRICULTUREASSIST", "CROP", "HORTICULTURE",
//     "FLORICULTURE", "SERICULTURE", "APICULTURE", "FISHERY", "ANIMALHUSBANDRY",
//     "DAIRY", "POULTRYFARM", "PIGGERY", "GOATREARING", "SHEEPHUSBANDRY",
//     "VETOFFICE", "VETERINARYDOCTOR", "VACCINATION", "ARTIFICIALSEED", "BREEDING",
//     "LIVESTOCKDEV", "FODDERDEV", "MILKUNION", "COOPERATIVE", "MILKCOOP",
//     "SUGARMILL", "SPINNING", "HANDLOOMCOOP", "FISHERIESDEV", "MINOR",
//     "MEDIUMIRR", "MAJORIRR", "CANAL", "DAM", "TUBEWELL",
//     "BORWELL", "PUMPSET", "DRIP", "SPRINKLER", "WATERCONSERVATION",
//     "WATERSHED", "PONDREJUV", "TANKRESTO", "WATERSUPPLY", "RURALPIPES",
//     "JALYOJANA", "HARKHETYOJANA", "KITKRANTI", "BHAVANTAR", "BONUS",
//     "KRUSHIGURU", "RYTHUBANDU", "RYTHUBANDHU", "BALIRAJA", "ANNADATA",
//     "INTERESTRELIEF", "LOANDISCOUNT", "INPUTSUB", "SEEDSUB", "FERTILIZERSUB",
//     "KRUSHIYANTRA", "TRACTORSUB", "IMPLEMENTS", "POWERTILLER", "WEEDER",
//     "THRESHER", "WAREHOUSE", "GODOWN", "COLDSTORAGE", "FOODGRAIN",
//     "PROCUREMENT", "PAYMENTFARMER", "DIRECTPAYMENT", "MSP", "PADDY",
//     "WHEAT", "COTTONSUPPORT", "SUGARCANE", "SOYBEANS", "PULSES",
//     "OILSEEDS", "COARSE", "MILLETS", "RAGI", "JOWAR",
//     "BAJRA", "GROUNDNUT", "CASHEW", "COCONUT", "ARECANUT",
//     "RUBBER", "TEA", "COFFEE", "CARDAMOM", "PEPPER",
//     "TURMERIC", "GINGER", "ONION", "POTATO", "TOMATO",
//     "BRINJAL", "LADIESFINGER", "CABBAGE", "CAULIFLOWER", "RADISH",
//     "BEETROOT", "CARROT", "BEANS", "PEAS", "CUCUMBER",
//     "PUMPKIN", "BITTERGOURD", "RIDGEGOURD", "BOTTLEGOURD", "BANANA",
//     "MANGO", "PAPAYA", "GUAVA", "SAPOTA", "CUSTARDAPPLE",
//     "POMEGRANATE", "GRAPES", "ORANGE", "LEMON", "STATEPWD",
//     "ENGINEERDEPT", "EXECUTIVENG", "ASSISTANTENG", "JUNIORENG", "DRAUGHTS",
//     "SURVEYOR", "OVERSEERS", "WORKCHARGE", "ROADWORK", "BRIDGEWORK",
//     "BUILDINGWORK", "DRAINAGE", "EMBANKMENT", "RETAINING", "FLYOVER",
//     "UNDERPASS", "CULVERT", "CAUSEWAY", "STORMWATER", "URBANINFRA",
//     "RURALSANITATION", "TOILET", "SEWAGETREAT", "SEPTICTANK", "SOLIDWASTE",
//     "PLASTIWASTE", "COMPOSTING", "RECYCLING", "DUMPYARD", "LANDFILL",
//     "WASTEPICKER", "SAFARKARAMCHARI", "CONSERVANCY", "STREETSWEEP", "DRAINS",
//     "MANHOLE", "UNCLOG", "DESILTING", "ROADSWEEP", "MECHANICAL"
//   ]
// }